import { render, staticRenderFns } from "./resImportList.vue?vue&type=template&id=2a5b456e&scoped=true&"
import script from "./resImportList.vue?vue&type=script&lang=js&"
export * from "./resImportList.vue?vue&type=script&lang=js&"
import style0 from "./resImportList.vue?vue&type=style&index=0&id=2a5b456e&prod&scoped=true&lang=css&"
import style1 from "./resImportList.vue?vue&type=style&index=1&id=2a5b456e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b456e",
  null
  
)

export default component.exports